import React from 'react';
import Grade1Letter from './Grade1Letter';

export default function LetterSequence({ value, size }) {
  return <span className="letter-sequence" style={size ? { '--glyph-size': `${size}px` } : undefined} aria-hidden="true">
    {[...value].map((letter, index) => <span key={index} className="sequence-glyph">
      <Grade1Letter letter={letter} />
    </span>)}
  </span>;
}
